// Week in Review block — click-to-play YouTube embed.
// Hooks into the .home-week-in-review / .wir-video markup emitted by
// craft/templates/pages/sub/_homeWeekInReview.twig.

const addAutoplay = (url) => {
    if (!url) return url
    const hasQuery = url.includes('?')
    const sep = hasQuery ? '&' : '?'
    const must = 'autoplay=1&mute=0&playsinline=1'
    return url.includes('autoplay=1') ? url : `${url}${sep}${must}`
}

const home = {
    init() {
        document.querySelectorAll('.home-week-in-review').forEach((wrap) => {
            const trigger = wrap.querySelector('[data-wir-video]')
            const embed = wrap.querySelector('.wir-embed')
            const iframe = embed?.querySelector('iframe')

            if (!trigger || !embed || !iframe) return

            trigger.addEventListener('click', function handler() {
                wrap.classList.add('is-playing')

                const dataSrc = iframe.getAttribute('data-src')
                if (dataSrc && !iframe.src) {
                    iframe.src = addAutoplay(dataSrc)
                } else {
                    iframe.src = addAutoplay(iframe.src)
                }

                trigger.removeEventListener('click', handler)
            })
        })
    }
}

export default home
